module.exports = __webpack_public_path__ + "img/credit.d0edd003.svg";